import type { ChatCycle } from "./types.js";

// CYCLES walk the four labeled steps (orient → search → inspect → compare) on
// gwas-index, so the animation demonstrates the progressive-disclosure surface
// described by the tool-flow legend on the GWASx solutions page. Numbers and
// rows mirror the verified live calls already shown elsewhere on the page
// (corpus snapshot 2026-07-22; Alzheimer's search; study GCST90027158,
// Bellenguez 2022; paper PMID 29703844, van Zuydam 2018).
export const GWASX_CYCLES: ChatCycle[] = [
  {
    server: "gwas-index · orient",
    user: "What's in the GWAS index?",
    tool: "corpus_overview",
    args: [],
    result: {
      kind: "rows",
      rows: [
        { accession: "studies", title: "GWAS Catalog studies", meta: "186,237" },
        { accession: "associations", title: "curated + computed hits", meta: "8.4M" },
        { accession: "traits", title: "ontology-grounded (EFO · MONDO)", meta: "100%" },
      ],
      chip: "~250 tokens",
    },
    assistant:
      "186,237 studies, 8.4M associations, every trait grounded to EFO/MONDO. What do you want to find?",
  },
  {
    server: "gwas-index · search",
    user: "Well-powered Alzheimer's disease studies.",
    tool: "search_studies",
    args: [
      { k: "trait", v: '"Alzheimer"' },
      { k: "category", v: '"disease"' },
      { k: "min_sample_size", v: "100000" },
    ],
    result: {
      kind: "rows",
      rows: [
        { accession: "GCST90027158", title: "Alzheimer's · Bellenguez C", meta: "N=487,511 · 87 GW-sig" },
        { accession: "GCST90301303", title: "Alzheimer's · Lake J", meta: "N=644,188 · 49 GW-sig" },
        { accession: "GCST005922", title: "Alzheimer's · Marioni RE", meta: "N=116,080 · 69 GW-sig" },
      ],
      chip: "~50 / result",
    },
    assistant:
      "92 well-powered studies, ranked and comparable — sample sizes and GW-significant counts as fields, not prose. Open one?",
  },
  {
    server: "gwas-index · inspect",
    user: "Top hits for GCST90027158.",
    tool: "study_detail",
    args: [{ k: "study_accession", v: '"GCST90027158"' }],
    result: {
      kind: "rows",
      rows: [
        { accession: "BIN1", title: "rs6733839 · intron", meta: "p=6e−118" },
        { accession: "CR1", title: "rs679515 · intron", meta: "p=7e−46" },
        { accession: "TREM2", title: "rs75932628 · missense", meta: "p=3e−37 · OR 2.39" },
      ],
      chip: "~500+ / record",
    },
    assistant:
      "Lead variants grounded to dbSNP, nearest genes to HGNC — computed from deposited summary stats, so a gene filter matches the gene.",
  },
  {
    server: "gwas-index · compare",
    user: "Are those 16 kidney records independent studies?",
    tool: "paper_overview",
    args: [{ k: "pmid", v: '"29703844"' }],
    result: {
      kind: "rows",
      rows: [
        { accession: "16", title: "accessions from one publication", meta: "van Zuydam 2018" },
        { accession: "16", title: "distinct traits (ESRD, T2D, GFR…)", meta: "one paper" },
        { accession: "1", title: "underlying study — not 16 replications", meta: "siblings linked" },
      ],
      chip: "~50 tokens",
    },
    assistant:
      "Sixteen accessions that look independent in a flat list, tied back to one publication — the difference between replication and slicing.",
  },
];
